import React from "react";
import { Box } from "@mantine/core";
import { motion } from "framer-motion";
import { ThemeType } from "../util/types";
import DynamicText from "./DynamicText";

type CaptionsListProps = {
  theme: ThemeType;
  captions: string[];
  onRenderComplete?: () => Promise<void>;
};

const CaptionsList = ({
  theme,
  captions,
  onRenderComplete = async () => {},
}: CaptionsListProps) => {
  return (
    <Box style={{ display: "flex", flexDirection: "column", width: "95%" }}>
      {captions.map((c, i) => {
        const text = i + 1 + ". " + c;
        return (
          <motion.div
            key={"caption" + i}
            initial={{ x: "calc(150vw)" }}
            animate={{ x: 0 }}
            transition={{ duration: 1, delay: i * 0.2 }}
            onAnimationComplete={async () => {
              if (i === captions.length - 1) {
                await onRenderComplete();
              }
            }}
          >
            <DynamicText
              style={{
                display: "flex",
                color: theme.TextColor,
                textAlign: "left",
                fontSize: 33 - captions.length - text.length / 10,
                marginTop: 0,
                marginBottom: 15,
                marginLeft: 25,
                justifyContent: "left",
              }}
            >
              {text}
            </DynamicText>
          </motion.div>
        );
      })}
    </Box>
  );
};

export default CaptionsList;
